import { render, staticRenderFns } from "./training-video.vue?vue&type=template&id=717307f3&"
import script from "./training-video.js?vue&type=script&lang=js&"
export * from "./training-video.js?vue&type=script&lang=js&"
import style0 from "./training-video.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports